import React, { useEffect, useRef } from "react";

import { classnames, Icon } from "@culturehq/components";
import { useIsMobile } from "app/hooks";
import { Trans } from "app/utils";

type MagicScriptProps = {
  hasSelectedVideo: boolean;
  magicScriptText?: string;
  onMagicScriptChange: (value: string) => void;
};

const MagicScript: React.FC<MagicScriptProps> = ({
  hasSelectedVideo,
  magicScriptText,
  onMagicScriptChange
}) => {
  const isMobile = useIsMobile();
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    // Focus the textarea when the component mounts {{ edit_2 }}
    if (textareaRef.current) {
      textareaRef.current.focus();
      textareaRef.current.setSelectionRange(
        textareaRef.current.value.length, textareaRef.current.value.length
      );
    }
  }, []);

  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onMagicScriptChange(event.target.value);
  };

  return (
    <div className="TextArea-Container">
      {!isMobile && (
        <div className="TextArea-Tip">
          <Icon icon="info-v2-filled" />
          <p>
            <Trans>
              This script below can be used as a teleprompter when you record
              your video. Be sure to edit this to make it feel more like you!
            </Trans>
          </p>
        </div>
      )}
      <textarea
        ref={textareaRef}
        className={classnames("MainContainerIntelligence__Textarea-txt no-scrollbar", "Prompter", { SmallTextArea: hasSelectedVideo })}
        onChange={handleTextChange}
        placeholder="Edit your script here..."
        value={magicScriptText}
      />
    </div>
  );
};

export default MagicScript;
